import React from 'react';

import { createDashboardPageClassName } from './dashboardPageStyles';

export const DashboardPageBody: React.FC = ({ children }) => (
  <div className={createDashboardPageClassName('body')}>
    <div className={createDashboardPageClassName('content')}>{children}</div>
  </div>
);
